export enum EmailAiTypes {
  Custom = 'custom',
  Rejection = 'rejection',
}

export type EmailAiResponse = {
  data: EmailAi;
};

export type EmailAi = {
  content: string;
  metadata: EmailAiResponseMetadata;
};

export type EmailAiResponseMetadata = {
  chatId: string;
  requestId: string;
};

export type RejectionEmailAiRequest = {
  template?: string;
};

export type CustomEmailAiRequest = {
  template?: string;
  message: string;
};

export type ContinueEmailAiRequest = {
  lastMessage: string;
  answer: string;
};

export type SuggestAi = {
  topics: [SuggestAiEntitiesEnum];
};

export enum SuggestAiEntitiesEnum {
  RejectionEmail = 'rejection_email',
}

export enum RejectionEmailLSKeys {
  RejectionEmail = 'rejectionEmail',
}

export interface EmailAiConfirmDialogResult {
  confirmed: boolean;
  payload: {
    dontShowAgain: boolean;
  };
}

export type RejectionEmailTriggerContext = 'dropdown' | 'banner';
